export default __webpack_public_path__ + "static/media/2004.cd08047b.png";